export default {
    dataDimension: true,
};
